import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { FaSignOutAlt, FaUserShield } from 'react-icons/fa';

const AdminPanel = ({ t, onLogout }) => {
  return (
    <div className="admin-panel">
      <Container>
        <div className="admin-content">
          <div className="mb-4">
            <FaUserShield size={60} color="var(--primary-color)" />
          </div>
          
          <h2 className="admin-title">{t.admin.welcome}</h2>
          
          <p className="text-muted mb-4">
            This is the admin dashboard. Future features will be added here.
          </p>
          
          <Button 
            variant="primary" 
            onClick={onLogout}
            className="btn-primary-custom"
          >
            <FaSignOutAlt className="me-2" />
            {t.admin.logout}
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default AdminPanel;